import React, { useContext, useEffect, useState } from "react";
import useFetch from "../../Hooks/useFetch";
import { useNavigate, useParams } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import AddMember from "../../Template/Home/Members/AddMember/AddMember";
import { membersURL } from "../../Hooks/URL";
import useFetchWhen from "../../Hooks/useFetchWhen";

function AddMemberPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();
  const params = useParams();

  const [member, setMember] = useState("");
  const {
    data: memberData,
    loading: memberLoading,
    error: memberError,
  } = useFetchWhen(`${membersURL}/${params?.id}`, params?.id);

  useEffect(() => {
    if (memberData?.data) setMember(memberData?.data);
  }, [memberData]);

  return <AddMember url={membersURL} editId={params?.id} member={member} />;
}

export default AddMemberPage;
